"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../gen-src/Localize");
var BeforeConnectingTelemetry_1 = require("./BeforeConnectingTelemetry");
exports.BeforeConnectingDialogContent = function (props) {
    if (props.connectionType === 'webdata-direct:ServiceNowITSM-ServiceNowITSM') {
        return (React.createElement("div", { style: { color: widgets_1.TabStyles.Typography.Color.Primary } },
            React.createElement("div", { style: { marginBottom: widgets_1.TabStyles.Spacing.LargeSpace } }, Localize_1.Messages.BeforeConnectingMessage({ DATA_SOURCE: props.connectionTypeDisplay })),
            React.createElement("div", { style: { marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace } }, Localize_1.Messages.ServiceNowContent())));
    }
    if (props.connectionType === 'webdata-direct:intuit-quickbooks') {
        return (React.createElement("div", { style: { color: widgets_1.TabStyles.Typography.Color.Primary } },
            React.createElement("div", { style: { marginBottom: widgets_1.TabStyles.Spacing.LargeSpace } }, Localize_1.Messages.BeforeConnectingMessage({ DATA_SOURCE: props.connectionTypeDisplay })),
            React.createElement("div", { style: { marginBottom: widgets_1.TabStyles.Spacing.LargeSpace } },
                React.createElement("strong", null, Localize_1.Messages.QuickbooksContent1Title()),
                " ",
                Localize_1.Messages.QuickbooksContent1()),
            React.createElement("div", { style: { marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace } },
                React.createElement("strong", null, Localize_1.Messages.QuickbooksContent2Title()),
                " ",
                Localize_1.Messages.QuickbooksContent2())));
    }
    return (React.createElement("div", { style: { marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace, color: widgets_1.TabStyles.Typography.Color.Primary } }, Localize_1.Messages.BeforeConnectingMessage({ DATA_SOURCE: props.connectionTypeDisplay })));
};
exports.BeforeConnectingDialogFooter = function (props) {
    return (React.createElement("div", { style: {
            display: 'flex', alignItems: 'center'
        } },
        React.createElement("div", { style: { marginRight: 'auto' } },
            React.createElement(widgets_1.ButtonWidget, { handleClick: props.onCancel, buttonType: widgets_1.ButtonType.Outline, children: Localize_1.Messages.Cancel(), testId: 'before-connecting-dialog-cancel' })),
        React.createElement("div", { style: { paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace } }, props.onProceedNoSignIn && React.createElement(widgets_1.ButtonWidget, { handleClick: props.onProceedNoSignIn, buttonType: widgets_1.ButtonType.Outline, children: Localize_1.Messages.ContinueNoSignIn(), testId: 'before-connecting-dialog-no-sign' })),
        React.createElement("div", { style: { paddingLeft: widgets_1.TabStyles.Spacing.MediumSpace } },
            React.createElement(widgets_1.ButtonWidget, { handleClick: props.onProceedSignIn, buttonType: widgets_1.ButtonType.Primary, children: Localize_1.Messages.Continue(), testId: 'before-connecting-dialog-ok' }))));
};
var BeforeConnectingDialog = /** @class */ (function (_super) {
    __extends(BeforeConnectingDialog, _super);
    function BeforeConnectingDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onCancel = function () {
            _this.beforeConnectingTelemetry.Cancel(_this.getOpenDuration());
            _this.props.onCancel();
        };
        _this.onProceedSignIn = function () {
            _this.beforeConnectingTelemetry.ContinueSignIn(_this.getOpenDuration());
            _this.props.onProceedSignIn();
        };
        _this.onProceedNoSignIn = function () {
            if (_this.props.onProceedNoSignIn) {
                _this.beforeConnectingTelemetry.ContinueNoSignIn(_this.getOpenDuration());
                _this.props.onProceedNoSignIn();
            }
        };
        _this.beforeConnectingTelemetry = new BeforeConnectingTelemetry_1.BeforeConnectingTelemetry(props.sendEventFn);
        return _this;
    }
    BeforeConnectingDialog.prototype.componentDidMount = function () {
        this.openTime = Date.now();
        this.beforeConnectingTelemetry.Open();
    };
    BeforeConnectingDialog.prototype.getOpenDuration = function () {
        var now = Date.now();
        var duration = now - this.openTime;
        return duration;
    };
    BeforeConnectingDialog.prototype.renderFooter = function () {
        var props = {
            connectionType: this.props.connectionType,
            connectionTypeDisplay: this.props.connectionTypeDisplay,
            onCancel: this.onCancel,
            onProceedSignIn: this.onProceedSignIn
        };
        if (this.props.onProceedNoSignIn) {
            props.onProceedNoSignIn = this.onProceedNoSignIn;
        }
        return React.createElement(exports.BeforeConnectingDialogFooter, __assign({}, props));
    };
    BeforeConnectingDialog.prototype.renderContent = function () {
        return (React.createElement("div", null,
            React.createElement("div", { style: {
                    color: widgets_1.TabStyles.Typography.Color.PrimaryMedium,
                    fontWeight: 'bold',
                    marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace
                } }, Localize_1.Messages.BeforeConnectingTitle()),
            React.createElement(exports.BeforeConnectingDialogContent, { connectionType: this.props.connectionType, connectionTypeDisplay: this.props.connectionTypeDisplay })));
    };
    BeforeConnectingDialog.prototype.render = function () {
        var dialogProps = {
            shouldReturnFocusOnClose: false,
            zIndex: 1031,
            dialogWidth: 500,
            type: widgets_1.DialogType.NormalWithTitleBar,
            title: Localize_1.Messages.BeforeConnectingDialogTitle({ DATA_SOURCE: this.props.connectionTypeDisplay }),
            showCloseButton: false,
            onCloseRequest: this.onCancel,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            isModal: true,
            testId: 'BeforeConnectingDialog',
            children: this.renderContent(),
            showFooter: true,
            footerContent: this.renderFooter()
        };
        return React.createElement(widgets_1.DialogWidget, __assign({}, dialogProps));
    };
    return BeforeConnectingDialog;
}(React.Component));
exports.BeforeConnectingDialog = BeforeConnectingDialog;
//# sourceMappingURL=BeforeConnectingDialog.js.map